import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.1);
    flex-direction: column;
`